import { BLOG_CATEGORY, buildBlogFilePath, type BlogMetaData } from '../types';

export const cupDrinkingPractice: BlogMetaData = {
  title: 'コップ飲みの練習はいつから？こぼす対処とストロー卒業のコツ3分',
  description:
    'コップ飲みの練習はいつから？ストローマグからの移行時期、こぼす時の対処法、3分でできる練習手順を保育士監修・モンテッソーリ視点で解説します。',
  thumbnailUrl: '/img/blog-cup-drinking-practice.webp',
  filePath: buildBlogFilePath('cup-drinking-practice'),
  category: BLOG_CATEGORY.PLAY_TOOLS,
};
